(function () {
  'use strict';

  /* @ngdoc object
   * @name user.agreements
   * @description
   *
   */
  angular
    .module('user.agreements', [
      'ui.router'
    ]);
}());
